// extracted by mini-css-extract-plugin
export default {"divLoader":"Loader_divLoader__aFun2","txtLoading":"Loader_txtLoading__HS4-P"};